import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/styles/makeStyles';
import { ebooksImagePath } from '@orientaction/utils';
import clsx from 'clsx';
import { FC } from 'react';

interface IProps {
  children: any;
  bannerContainerOverride?: string;
  bannerStyleOverride?: string;
  childrenContainerOverride?: string;
}

const DoubleBanner: FC<IProps> = ({
  children,
  bannerContainerOverride = '',
  bannerStyleOverride = '',
  childrenContainerOverride = '',
}) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.bannerContainer, bannerContainerOverride)}>
      <img
        className={clsx(classes.banner, bannerStyleOverride)}
        src={`${ebooksImagePath}/doubleBanner.svg`}
        alt="double banner"
      />
      <div className={clsx(classes.childrenContainer, childrenContainerOverride)}>{children}</div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bannerContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: 500,
      height: 100,
      margin: 'auto',
      marginTop: 20,
      marginBottom: 20,
      [theme.breakpoints.down(1300)]: {
        width: 300,
      },
    },
    banner: {
      width: '100%',
      // display: 'block',
      margin: 'auto',
      marginTop: 0,
    },
    childrenContainer: {
      // marginTop: -63,
    },
  }),
);

export default DoubleBanner;
